export default "__VITE_ASSET__6ebbb423__"